import { axiosinstance } from '../axiosClient';
import type { ClientAnalyticsPayload } from '../utils/ClientAnalytics';

const postUserAnalyticsCore = async (
  payload: ClientAnalyticsPayload,
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.post(
    '/bp_user_analytics_information',
    {},
    {
      headers: {
        Authorization: 'Bearer ' + String(auth?.accessToken || ''),
        ...payload,
      },
      timeout: 15000,
    },
  );
};

export const postUserAnalytics = async (
  payload: ClientAnalyticsPayload,
  auth: { accessToken?: string | null },
) => {
  try {
    const response = await postUserAnalyticsCore(payload, auth);
    console.log('postUserAnalytics response', response);
    return response;
  } catch (error) {
    console.log('postUserAnalytics error', error);
    return error;
  }
};
